export default {
  EET_SCALE_MANAGER_RESIZE: 'scaleManager: resize',
}
